import { ChangeEventHandler, FC, Fragment, useMemo } from 'react';

import { isEmpty } from 'remeda';

import TextField from '@mui/material/TextField';

import { AddFreeSpinsForm } from '../form';

import { DynabitFreeSpinsParam } from './dynabitFreeSpinsParam/DynabitFreeSpinsParam';
import { EvoplayFreeSpinsParam } from './evoplayFreeSpinsParam/EvoplayFreeSpinsParam';
import { getBetOptions } from './utils';

import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Select } from 'v2/components/select/Select';
import { ProviderName } from 'v2/constants';
import {
  AnyFreeSpinInfoModel,
  DynabitGameFreeSpinInfoModel,
  EvoplayGameFreeSpinInfoModel,
} from 'v2/types/FreeSpinModel';

interface FreeSpinsInfoParamsProps {
  info: AnyFreeSpinInfoModel;
  values: AddFreeSpinsForm;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onSelectChange: (field: keyof AddFreeSpinsForm) => (v: unknown) => void;
}

export const FreeSpinsInfoParams: FC<FreeSpinsInfoParamsProps> = ({ info, values, onChange, onSelectChange }) => {
  if (isEmpty(info.availableBets)) {
    return <EmptyPlaceholder text="It's impossible to create free spins for this slot" />;
  }

  const betOptions = useMemo(() => {
    return getBetOptions(info.availableBets, values.providerName);
  }, [info, values]);

  return values.providerName === ProviderName.EVOPLAY ? (
    <EvoplayFreeSpinsParam
      info={info as EvoplayGameFreeSpinInfoModel}
      values={values}
      onChange={onChange}
      onSelectChange={onSelectChange}
      betOptions={betOptions}
    />
  ) : (
    <Fragment>
      <div className="form-group">
        <TextField
          name="countSpins"
          value={values.countSpins}
          label="Spins Count"
          onChange={onChange}
          type="number"
          required
          fullWidth
        />

        <Select
          value={!values.betSpins ? undefined : values.betSpins}
          options={betOptions}
          label="Bet"
          onChange={onSelectChange('betSpins')}
          required
        />
      </div>

      {values.providerName === ProviderName.DYNABIT && (
        <DynabitFreeSpinsParam
          info={info as DynabitGameFreeSpinInfoModel}
          values={values}
          onLinesAmountChange={onSelectChange('linesAmount')}
        />
      )}
    </Fragment>
  );
};
